export const HOME = "Home";
export const LOGIN = "Login";
export const ExportTemplatePdf = "ExportTemplatePdf";
export const ExportTemplateExcelCsv = "ExportTemplateExcelCsv";
export const ExportMail = "ExportMail";
export const ExportMailMaintenance = "ExportMailMaintenance";
export const OperationsExpired = "OperationsExpired";
export const OperationsDaily = "OperationsDaily";
export const OperationsHourly = "OperationsHourly";
export const OperationsPeriodical = "OperationsPeriodical";
export const OperationsCompare = "OperationsCompare";
export const Accounting = "Accounting";
export const AzureCost = "AzureCost";
export const KioskGlobal = "KioskGlobal";
export const KioskGlobalUpdated = "KioskGlobalUpdated";
export const KioskCompare = "KioskCompare";
export const Games = "Games";
export const GamesCode = "GamesCode";
export const GamesSimple = "GamesSimple";
export const GamesCompare = "GamesCompare";
export const Snacking = "Snacking";
export const Merchandising = "Merchandising";
export const Staff = "Staff";
export const StaffHistory = "StaffHistory";
export const Cards = "Cards";
export const OmniplayReport = "OmniplayReport";
export const SmartTouchMaintenance = "SmartTouchMaintenance";
export const OmniplayEvents = "OmniplayEvents"
export const BusinessOmniplayEventsPresta = "BusinessOmniplayEventsPresta"
export const BusinessOmniplayEventsOrder = "BusinessOmniplayEventsOrder"
export const BusinessOmniplayEventsPrestaSimple = "BusinessOmniplayEventsPrestaSimple"
export const BusinessOmniplayEventsOrderSimple = "BusinessOmniplayEventsOrderSimple"
export const Cake = "Cake"
export const ConsumptionReport = "ConsumptionReport"